import React from 'react';
const Search = ({
  className = 'actions-table__search search-input',
  onChange,
  style,
}) => {
  return (
    <div className={className} style={style}>
      <input placeholder="Buscar" onChange={(e) => onChange(e)} />
      <span className="search-input__icon material-symbols-outlined">
        search
      </span>
    </div>
  );
};
export default Search;
